﻿import { GuiAuswertung } from "./GuiAuswertung";
import { Chart } from "../chart-setup";
import { IChartData } from "../Interface/IChartData"
export class GuiAuswertungCO2Bilanz extends GuiAuswertung {

        private chart?: Chart;

        constructor() {
            super("GuiAuswertungCO2Bilanz");
        }

         override draw() {

            const ctx = document.getElementById("chartAbfallbilanz") as HTMLCanvasElement;
            if (this.chart != undefined) {
                this.chart.destroy();
            }

            const jsonData = (<HTMLInputElement>document.getElementById("jsonAbfallbilanz")).value;
            if (jsonData == undefined || jsonData === "null") { return; }

            const pieData = JSON.parse(jsonData) as IChartData;
            const data = {
                labels: pieData.labels,
                datasets: [{
                    label: "Abfallbilanz",
                    data: pieData.values,
                    backgroundColor: pieData.colors,
                    hoverOffset: 4
                }]
            };

            this.chart = new Chart(ctx, this.CreateDoughnutConfig(data, pieData.valuesArePercent));
        }
    }
